module.exports = __webpack_public_path__ + "img/044.e56532b6.png";